import { useEffect, useState } from 'preact/hooks';

/** Explicit preference wins over OS; safely degrades when storage is blocked. */
export function ThemeToggle() {
  const [dark, setDark] = useState(document.documentElement.dataset.theme === 'dark');
  useEffect(() => {
    const media = matchMedia('(prefers-color-scheme: dark)');
    const apply = (value: boolean) => {
      setDark(value);
      document.documentElement.dataset.theme = value ? 'dark' : 'light';
      document.querySelector('meta[name="theme-color"]')?.setAttribute('content', value ? '#151914' : '#f6f7f2');
    };
    const sync = () => {
      let saved: string | null = null;
      try { saved = localStorage.getItem('dinkr-theme'); } catch {}
      apply(saved === 'dark' || (saved !== 'light' && media.matches));
    };
    const storage = (e: StorageEvent) => { if (e.key === 'dinkr-theme' || e.key === null) sync(); };
    media.addEventListener('change', sync);
    window.addEventListener('storage', storage);
    return () => { media.removeEventListener('change', sync); window.removeEventListener('storage', storage); };
  }, []);
  const toggle = () => {
    const next = !dark;
    setDark(next);
    document.documentElement.dataset.theme = next ? 'dark' : 'light';
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', next ? '#151914' : '#f6f7f2');
    try { localStorage.setItem('dinkr-theme', next ? 'dark' : 'light'); } catch {}
  };
  return <button type="button" class="iconbtn theme-toggle" onClick={toggle} aria-label="โหมดกลางคืน" aria-pressed={dark} title={dark ? 'เปลี่ยนเป็น Day mode' : 'เปลี่ยนเป็น Night mode'}>
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true">
      {dark ? <path d="M20.5 13A8.5 8.5 0 0 1 11 3.5 8.5 8.5 0 1 0 20.5 13Z" /> : <><circle cx="12" cy="12" r="4" /><path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5" /></>}
    </svg>
  </button>;
}
